import { ApiObjectService } from './api-object.service'

class DictionaryCoveringsService extends ApiObjectService {
    namespace = 'dictionary-coverings'
}

export const dictionaryCoveringsService = new DictionaryCoveringsService()
